import { inject, Pipe, type PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import { LocaleService } from 'src/app/services/locale.service';

@Pipe({
  name: 'timeUntil',
  pure: true,
})
export class TimeUntilPipe implements PipeTransform {
  private readonly localeService = inject(LocaleService);

  transform(value: number): string {
    if (!value) {
      return '';
    }

    const diffInMs = dayjs(value).diff(dayjs());

    if (diffInMs <= 0) {
      return this.localeService.humanize(0);
    }

    return this.localeService.humanize(diffInMs);
  }
}
